export const mimetypeToFriendlyName = {
  "image/jpeg": "JPEG Image",
  "image/jpg": "JPEG Image",
  "image/png": "PNG Image",
  "image/webp": "WebP Image",
  "application/pdf": "PDF Document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "Word Document (DOCX)",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    "Excel Spreadsheet (XLSX)",
  "text/plain": "Text File (TXT)",
  "text/csv": "CSV File",
  "text/html": "HTML Document",
  "application/xhtml+xml": "XHTML Document",
} as const;

export type MimetypeKeys = keyof typeof mimetypeToFriendlyName;

export const formatMimetypeToFriendlyName = (mimetype: string) => {
  return mimetypeToFriendlyName[
    mimetype as keyof typeof mimetypeToFriendlyName
  ];
};

export function getAllowedFiles(arr?: Array<MimetypeKeys>) {
  const filtered = Object.entries(mimetypeToFriendlyName).filter(([key]) => {
    if (arr) {
      return arr.includes(key as MimetypeKeys);
    }
    return true;
  });
  return Array.from(new Set(filtered.map((item) => item[1])));
}

export type FileType =
  | "image"
  | "docx"
  | "spreadsheet"
  | "pdf"
  | "csv"
  | "html"
  | "unknown";

export function getFileType(file: File): FileType {
  const mimeType = file.type;

  if (mimeType.startsWith("image/")) {
    return "image";
  }

  switch (mimeType) {
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "docx";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    case "application/vnd.ms-excel":
      return "spreadsheet";
    case "application/pdf":
      return "pdf";
    case "text/csv":
      return "csv";
    case "text/html":
      return "html";
    default:
      return "unknown";
  }
}
